module.exports = __webpack_public_path__ + "img/not-authorized-dark.f271cfe4.svg";